import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Container, Icon, Content, Title, Message, CloseButton } from './Toast.styles'

const variantIcons = {
  success: CheckCircleIcon,
  fail: ErrorOutlineIcon,
  error: ErrorOutlineIcon,
  information: InfoOutlinedIcon
}

const variantIconColors = {
  success: '#00a24d',
  fail: '#d32f2f',
  error: '#d32f2f',
  information: '#f7b500'
}

const defaultTitles = {
  success: 'Éxito',
  fail: 'Error',
  error: 'Error',
  information: 'Información'
}

const Toast = ({ visible, variant, title, message, duration, onClose, closeable, toastKey }) => {
  useEffect(() => {
    if (!visible) {
      return undefined
    }

    const timer = window.setTimeout(() => {
      if (typeof onClose === 'function') {
        onClose()
      }
    }, duration)

    return () => {
      window.clearTimeout(timer)
    }
  }, [visible, duration, onClose, toastKey])

  const IconComponent = variantIcons[variant] || variantIcons.information
  const iconColor = variantIconColors[variant] || variantIconColors.information

  return (
    <Container visible={visible} variant={variant} role="status" aria-live="polite">
      <Icon aria-hidden="true">
        <IconComponent htmlColor={iconColor} fontSize="medium" />
      </Icon>
      <Content>
        <Title>{title || defaultTitles[variant] || defaultTitles.information}</Title>
        <Message>{message}</Message>
      </Content>
      {closeable && (
        <CloseButton type="button" onClick={onClose} aria-label="Cerrar notificación">
          ×
        </CloseButton>
      )}
    </Container>
  )
}

Toast.propTypes = {
  visible: PropTypes.bool,
  variant: PropTypes.oneOf(['success', 'fail', 'error', 'information']),
  title: PropTypes.string,
  message: PropTypes.string,
  duration: PropTypes.number,
  onClose: PropTypes.func,
  closeable: PropTypes.bool,
  toastKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

Toast.defaultProps = {
  visible: false,
  variant: 'information',
  title: '',
  message: '',
  duration: 5000,
  onClose: undefined,
  closeable: false,
  toastKey: 0
}

export default Toast
